import { Byte, Encoder } from '@nuintun/qrcode';

import { BambiShortLogo } from '../logos/BambiShortLogo';

interface QRCodeProps {
  text: string;
  width?: HTMLImageElement['width'];
  height?: HTMLImageElement['height'];
  className?: string;
}
export function QRCode({ text, width, height, className }: QRCodeProps) {
  const encoder = new Encoder({
    level: 'H',
  });

  const qrcode = encoder.encode(new Byte(text));

  return (
    <div className="relative">
      <img
        src={qrcode.toDataURL()}
        width={width}
        height={height}
        className={className}
        alt={`QRCode for ${text}`}
      />
      <div
        style={{
          position: 'absolute',
          left: 'calc(50% - 8px)',
          top: 'calc(50% - 11px)',
          transform: 'scale(2)',
          background: 'white',
        }}
      >
        <BambiShortLogo />
      </div>
    </div>
  );
}
